import type { DrawingSettings, StrokePoint } from "../canvas/canvasTypes";
import type { Rect } from "../comic/comicTypes";
import type { StrokeCommand } from "./historyTypes";

let commandSequence = 0;

export function createStrokeCommand(
  layerId: string,
  settings: DrawingSettings,
  points: ReadonlyArray<StrokePoint>,
  panel?: { panelId: string; clipRect: Rect },
): StrokeCommand;
export function createStrokeCommand(
  settings: DrawingSettings,
  points: ReadonlyArray<StrokePoint>,
  panel?: { panelId: string; clipRect: Rect },
): StrokeCommand;
export function createStrokeCommand(
  layerIdOrSettings: string | DrawingSettings,
  settingsOrPoints: DrawingSettings | ReadonlyArray<StrokePoint>,
  pointsOrPanel?: ReadonlyArray<StrokePoint> | { panelId: string; clipRect: Rect },
  possiblePanel?: { panelId: string; clipRect: Rect },
): StrokeCommand {
  const legacy = typeof layerIdOrSettings !== "string";
  const layerId = legacy ? "legacy-raster" : layerIdOrSettings;
  const settings = (legacy ? layerIdOrSettings : settingsOrPoints) as DrawingSettings;
  const points = (legacy ? settingsOrPoints : pointsOrPanel) as ReadonlyArray<StrokePoint>;
  const panel = (legacy ? pointsOrPanel : possiblePanel) as
    { panelId: string; clipRect: Rect } | undefined;
  const immutablePoints = points.map((point) =>
    Object.freeze({ x: point.x, y: point.y, pressure: point.pressure }),
  );

  commandSequence += 1;
  return Object.freeze({
    kind: "stroke" as const,
    id: `stroke-${commandSequence}`,
    layerId,
    settings: Object.freeze({ ...settings }),
    points: Object.freeze(immutablePoints),
    panelId: panel?.panelId,
    clipRect: panel ? Object.freeze({ ...panel.clipRect }) : undefined,
  });
}

export function estimateStrokeCommandBytes(command: StrokeCommand): number {
  const textBytes = (command.settings.colour.length + command.settings.tool.length) * 2;
  return 112 + textBytes + command.points.length * 24;
}
